import { useMemo } from 'react';

import ForgotPasswordPhonePage from '~/components/auth/ForgotPassword';
import PasswordSetupPage from '~/components/auth/PasswordSetup';
import SignInPage from '~/components/auth/SignIn';
import VerifyAccountPage from '~/components/auth/VerifyAccount';
import VerifyPhonePage from '~/components/auth/VerifyPhone';
import CareTeamConnectionsForm from '~/components/connections/CareTeamConnectionsForm';
import CareTeamConnectionsList from '~/components/connections/CareTeamConnectionsList';
import Consents from '~/components/consents/ConsentsScreen';
import Document from '~/components/consents/Document';
import HipaaConsent from '~/components/consents/HipaaConsent';
import RWEConsent from '~/components/consents/RWEConsent';
import CreateAccountPage from '~/components/createAccount/CreateAccount';
import { NotFoundPage } from '~/components/global/NotFoundPage';
import AccountInformation from '~/components/settings/AccountInformation';
import UpdateEmailPage from '~/components/settings/UpdateEmail';
import UpdatePasswordPage from '~/components/settings/UpdatePassword';
import UpdatePhonePage from '~/components/settings/UpdatePhone';
import { InitializationErrorPage } from '~/components/utility/InitializationErrorPage';

const routes = [
  { route: 'account-information', component: AccountInformation },
  { route: 'update-password', component: UpdatePasswordPage },
  { route: 'hipaa', component: HipaaConsent },
  { route: 'rwe', component: RWEConsent },
  { route: 'terms-of-use', component: Document, props: { type: 'toulactate' } },
  {
    route: 'privacy-notice',
    component: Document,
    props: { type: 'pnlactate' },
  },
  { route: 'consents', component: Consents },
  // CLM routes
  { route: 'login', component: SignInPage },
  { route: 'create-account', component: CreateAccountPage },
  { route: 'verify-account', component: VerifyAccountPage },
  { route: 'password-setup', component: PasswordSetupPage },
  { route: 'forgot-password', component: ForgotPasswordPhonePage },
  { route: 'update-phone', component: UpdatePhonePage },
  { route: 'update-email', component: UpdateEmailPage },
  { route: 'verify-phone', component: VerifyPhonePage },
  { route: 'add-connection', component: CareTeamConnectionsForm },
  { route: 'connections', component: CareTeamConnectionsList },
] as const;

const useRouter = ({
  location,
  initErrorStatus,
}: {
  location: string;
  initErrorStatus?: number;
}) => {
  const Component = useMemo(() => {
    if (initErrorStatus) {
      return <InitializationErrorPage errorStatus={initErrorStatus} />;
    }

    const route = routes.find((r) => location === `/${r.route}`);

    if (route) {
      if ('props' in route) {
        return <route.component {...route.props} />;
      }

      return <route.component />;
    }

    return <NotFoundPage />;
  }, [initErrorStatus, location]);

  return Component;
};

export default useRouter;
